import angular from 'angular';
import gettext from 'angular-gettext';
import cmsACL from '../../ACL/ACLService';
import './menu.scss';

/**
 * @memberOf cms.input.menu
 * @property {object}   bindings.errors     Form errors object
 * @property {string}   bindings.model      Input value reference
 * @property {string}   bindings.label      Input title and/or placeholder
 * @property {string}   bindings.helper     Helper message for input
 * @property {string}   bindings.labelSize  Label column size (1-12)
 * @property {string}   bindings.inputSize  Input column size (1-12)
 * @property {string}   bindings.aclShow    ACL config - show input
 * @property {string}   bindings.aclDisable ACL config - disable input
 */
let cmsInputMenu = {
    bindings: {
        errors: '<',
        model: '=',
        label: '@',
        helper: '@',
        labelSize: '@',
        inputSize: '@',
        aclShow: '<?',
        aclDisable: '<?'
    },
    template: require('./menu.html'),
    controller: function ($scope, gettextCatalog) {
        this.onChange = () => {
            $scope.$emit('content-changed');
        };

        this.scrollToSection = (sectionUid) => {

            let navigationHeight = 147;

            let scrollPos = $('.' + sectionUid).offset().top - navigationHeight;
            $('html').animate({
                scrollTop: scrollPos
            }, 500);

        };

        this.toggleVisible = (anchor) => {
            anchor.visible = !anchor.visible;
        };

        this.sectionPlaceholder = (index) => {
            return gettextCatalog.getString('Section {{index}} title', {'index':index});
        };
    }
};

/**
 * Text control
 * @namespace cms.input.text
 */
export default angular.module('cms.input.menu', [cmsACL, gettext]).component('cmsInputMenu', cmsInputMenu).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Controls/MenuControl/CmsInputMenu.js